import { useQuery } from "shared/hooks/useApi";
import { INSURANCE_PLANS } from "utils/api/graphql/queries/insurance-plans";

export const insurancePlansVariables = (selectedIds) => {
  const ids = (selectedIds || []).filter(Boolean);
  if (ids.length) return { isIn: { id: ids } };
  return { where: {} };
};

export const useInsurancePlans = (enabled, selectedIds) => {
  const { data } = useQuery(INSURANCE_PLANS, {
    variables: insurancePlansVariables(selectedIds),
    skip: !enabled,
  });
  return { insurancePlans: data?.insurancePlans?.data || [] };
};
